export const BRAND = {
  name: "Ever Sky Overseas",
  tagline: "Your Gateway to Global Education",
  description:
    "Ever Sky Overseas is a trusted study-abroad consultancy helping Indian students secure admissions, visas, scholarships, and everything they need to succeed abroad.",
  email: "info@everskyoverseas.com",
  phone: "+91 98765 43210",
  whatsapp: "+919876543210",
  address: "301, Skyline Business Hub, SG Highway, Ahmedabad, Gujarat 380015, India",
  website: "www.everskyoverseas.com",
  founder: "N. Singh Rajput",
  foundedYear: 2018,
  social: {
    facebook: "https://facebook.com/everskyoverseas",
    instagram: "https://instagram.com/everskyoverseas",
    linkedin: "https://linkedin.com/company/everskyoverseas",
    youtube: "https://youtube.com/@everskyoverseas",
  },
};
